import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["compareValues", "value", "onChange", "children", "theme", "data-e2e"];
import "core-js/modules/es.function.name.js";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import cn from 'classnames';
import { Button } from '@rescui/button';
import { LeftIcon, RightIcon } from '@rescui/icons';
import { useTheme } from '@rescui/ui-contexts';
import { useScrollableList } from './use-scrollable-list.js';
import styles from './with-scroll-arrows.p.module.css.js';

var compareTabsDefault = function compareTabsDefault(activeValue, tabValue) {
  return activeValue === tabValue;
};

var withScrollArrows = function withScrollArrows(WrappedComponent, CompareItem) {
  var arrowHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '100%';

  var WithScrollArrowsComponent = function WithScrollArrowsComponent(_ref) {
    var _ref$compareValues = _ref.compareValues,
        compareValues = _ref$compareValues === void 0 ? compareTabsDefault : _ref$compareValues,
        value = _ref.value,
        onChange = _ref.onChange,
        children = _ref.children,
        themeFromProps = _ref.theme,
        e2eId = _ref['data-e2e'],
        restProps = _objectWithoutProperties(_ref, _excluded);

    var theme = useTheme(themeFromProps);

    var _useScrollableList = useScrollableList({
      children: children,
      compareValues: compareValues,
      value: value,
      CompareItem: CompareItem
    }),
        selectedId = _useScrollableList.selectedId,
        prepareDirectionScroller = _useScrollableList.prepareDirectionScroller,
        activeNodeRef = _useScrollableList.activeNodeRef,
        scrollableRef = _useScrollableList.scrollableRef,
        containerRef = _useScrollableList.containerRef,
        childrenWithValues = _useScrollableList.childrenWithValues,
        showLeftArrow = _useScrollableList.showLeftArrow,
        showRightArrow = _useScrollableList.showRightArrow;

    var arrowStyles = {
      height: arrowHeight
    };
    return /*#__PURE__*/React.createElement("div", {
      className: cn(styles.wrapper, styles[theme])
    }, /*#__PURE__*/React.createElement("div", {
      className: cn(styles.arrow, styles.arrowLeft, showLeftArrow && styles.shown),
      "data-e2e": e2eId,
      style: arrowStyles,
      "data-test": 'scrollable-list-arrow-left-wrapper'
    }, /*#__PURE__*/React.createElement(Button, {
      theme: theme,
      mode: "clear",
      notFocusable: true,
      onClick: prepareDirectionScroller('left'),
      icon: /*#__PURE__*/React.createElement(LeftIcon, null),
      size: "s",
      "data-e2e": e2eId ? "".concat(e2eId, "__left-arrow") : null,
      "data-test": 'scrollable-list-arrow-left'
    })), /*#__PURE__*/React.createElement("div", {
      className: cn(styles.scrollable, showLeftArrow && styles.withLeftArrow, showRightArrow && styles.withRightArrow),
      ref: scrollableRef,
      tabIndex: -1
    }, /*#__PURE__*/React.createElement(WrappedComponent, _objectSpread({
      selectedId: selectedId,
      activeNodeRef: activeNodeRef,
      value: value,
      onChange: onChange,
      theme: theme,
      "data-e2e": e2eId,
      containerRef: containerRef
    }, restProps), childrenWithValues)), /*#__PURE__*/React.createElement("div", {
      className: cn(styles.arrow, styles.arrowRight, showRightArrow && styles.shown),
      style: arrowStyles,
      "data-test": 'scrollable-list-arrow-right-wrapper'
    }, /*#__PURE__*/React.createElement(Button, {
      theme: theme,
      mode: "clear",
      notFocusable: true,
      onClick: prepareDirectionScroller('right'),
      icon: /*#__PURE__*/React.createElement(RightIcon, null),
      className: styles.arrowButton,
      size: "s",
      "data-e2e": e2eId ? "".concat(e2eId, "__right-arrow") : null,
      "data-test": 'scrollable-list-arrow-right'
    })));
  };

  WithScrollArrowsComponent.displayName = "withScrollArrows(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
  return WithScrollArrowsComponent;
};

export { withScrollArrows };
